import {
	GET_ALL_COMPONENTS,
	POST_NEW_COMPONENT,
	SEND_LINK_REQUEST,
	PUT_COMPONENT,
	DELETE_COMPONENT,
	POST_SEND_INSTRUCTIONS,
	CLEAN_COMPONENTS_AND_FORMACTIONS
} from '../actiontypes';
import {GroupAuditComponentUrl, getAllComponentsUrl, CreateSendLinkRequestUrl} from '../apiUrls';
import {GALinkStatus, ExpandValues} from '../../util/uiconstants';

/**
 * Returns an action to be dispatched and treated by the api-middleware, ultimately making an API call through Axios.
 * Represents a request all the active components for the given engagements.
 * @param {Number} engagementId Engagement ID.
 * @param {String} expand expand value.
 * @param {Object} pagingValues paging values.
 * @param {Array} excludedGALinkStatusId Excluded GALinkStatusId.
 * @param {Array} excludedGAScopeTypeId Excluded GAScopeTypeId.
 * @returns {Object} An action object.
 */
//TODO: Analyze if we can move the pagination values to another action.
export const getAllComponents = (
	engagementId,
	expand = ExpandValues.GAScopes,
	pagingValues = {},
	excludedGALinkStatusId,
	excludedGAScopeTypeId
) => {
	let url = getAllComponentsUrl(engagementId, expand);

	if (expand === ExpandValues.AllExceptReference) {
		url = `${url}&page=${pagingValues.page}&pageSize=${pagingValues.pageSize}`;
	}

	if (excludedGALinkStatusId?.length > 0) {
		const gaLinkStatusParams = excludedGALinkStatusId?.map((gaLinkStatusId) => {
			return `&excludedGALinkStatusId=${gaLinkStatusId}`;
		});

		url = `${url}${gaLinkStatusParams.join('')}`;
	}

	if (excludedGAScopeTypeId?.length > 0) {
		const gaScopeTypeParams = excludedGAScopeTypeId?.map((gaSCopeTypeId) => {
			return `&excludedGAScopeTypeId=${gaSCopeTypeId}`;
		});

		url = `${url}${gaScopeTypeParams.join('')}`;
	}

	return {
		type: GET_ALL_COMPONENTS,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		},
		expand,
		resolve: true
	};
};

export const createNewComponent = (engagementId, payload) => {
	const url = GroupAuditComponentUrl(engagementId);
	return {
		type: POST_NEW_COMPONENT,
		meta: {
			api: {
				url,
				method: 'POST',
				data: payload
			}
		},
		gaLinkStatusId: payload.notUsingCanvas ? GALinkStatus.ComponentNotUsingCanvas : null
	};
};

export const editComponent = (engagementId, payload, componentId) => {
	const url = GroupAuditComponentUrl(engagementId) + '/' + componentId;
	let data = {
		gaScopeId: payload.gaScopeId,
		scopeName: payload.scopeName,
		gaParentComponentId: payload.gaParentComponentId,
		shortName: payload.shortName,
		pocEmail: payload.pocEmail,
		pocText: payload.pocText,
		pocGui: payload.pocGui,
		notUsingCanvas: payload.notUsingCanvas,
		gaRoleTypeId: payload.gaRoleTypeId
	};
	payload.pocgui = payload.pocGui;

	const getPathData = (obj) => {
		let path = [];
		Object.entries(obj).forEach(([key, value]) => {
			path.push({op: 'replace', path: key, value: value});
		});
		return path;
	};

	return {
		type: PUT_COMPONENT,
		meta: {
			api: {
				url,
				method: 'PATCH',
				data: getPathData(data)
			}
		},
		payload: {...payload, gaComponentId: componentId}
	};
};

export const sendLinkRequest = (engagementId, payload) => {
	const url = CreateSendLinkRequestUrl(engagementId);
	return {
		type: SEND_LINK_REQUEST,
		meta: {
			api: {
				url,
				method: 'POST',
				data: payload
			}
		},
		...payload
	};
};

export const deleteComponent = (engagementId, componentId) => {
	const url = `${GroupAuditComponentUrl(engagementId)}/${componentId}`;
	return {
		type: DELETE_COMPONENT,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		},
		componentId
	};
};

export const postSendInstructions = (engagementId, componentId) => {
	const url = `${GroupAuditComponentUrl(engagementId)}/${componentId}/SendInstructions`;
	return {
		type: POST_SEND_INSTRUCTIONS,
		meta: {
			api: {
				url,
				method: 'POST'
			}
		},
		componentId
	};
};

export const cleanComponentsAndFormActions = () => {
	return {
		type: CLEAN_COMPONENTS_AND_FORMACTIONS
	};
};
